import React from 'react'
import { Icon } from 'evergreen-ui'
const RoundBtn = ({
  action
}) => (
    <button className='round-btn' onClick={() => action()}>
      <Icon icon='plus' size={20} color='#fff' />
    </button>
  )

export default RoundBtn